import React from 'react';

import { Sparkles } from '@videoblocks/react-icons';

import { Button } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Button/Button';
import ModalDialog from '../../../../Shared/ModalDialog';

interface MoreCreditConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => any;
  onCancel: () => void;
}

const MoreCreditConfirmationModal: React.FC<
  MoreCreditConfirmationModalProps
> = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <ModalDialog
      isOpen={isOpen}
      onRequestClose={onCancel}
      headerText="You don't have enough credits to generate."
      contentLabelClassName="font-normal mt-0 mb-10 text-gray-900"
      subHeaderText={
        <>
          <div className="mb-4">
            This generation will cost 750 credits. To purchase more credits now,
            visit our upgrade page.
          </div>
        </>
      }
      className="max-w-xl p-8"
      topOffsetClass="top-1/2 transform -translate-y-1/2"
      subHeaderTextClassName="text-base text-gray-900"
      contentLabelContainerClassName="space-y-0"
      closeButtonClassName="text-gray-700 font-light"
    >
      <div className="flex gap-3 justify-end">
        <Button variant="outlined-dark" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onConfirm}>
          <div className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 fill-black" />
            Upgrade plan
          </div>
        </Button>
      </div>
    </ModalDialog>
  );
};

export default MoreCreditConfirmationModal;
